<main class="auth-main-container">
  <p-toast />
  <router-outlet></router-outlet>
</main>
